export type ErrorPayload = { errorCode?: number; title?: string; message?: string };

// The generated ApiClient propagates raw AxiosError (parsed body at err.response.data),
// but some surfaces may still throw NSwag's ApiException (parsed body at err.result, raw at err.response).
export function parseErrorPayload(err: unknown): ErrorPayload | null {
  if (typeof err !== 'object' || err === null) return null;
  const e = err as { response?: unknown; result?: unknown };

  if (e.result && typeof e.result === 'object') return e.result as ErrorPayload;

  const response = e.response;
  if (response && typeof response === 'object') {
    const data = (response as { data?: unknown }).data;
    if (data && typeof data === 'object') return data as ErrorPayload;
  }
  if (typeof response === 'string') {
    try {
      return JSON.parse(response) as ErrorPayload;
    } catch {
      return null;
    }
  }
  return null;
}

// The server already waited 15 s for another save in the brand, usually an import, before giving up with
// this code. Nothing was written, so a single retry is safe for calls that are one save with no side effects.
const NUMBER_LOCK_TIMEOUT = 4090;

export async function retryOnNumberLockTimeout<T>(call: () => Promise<T>): Promise<T> {
  try {
    return await call();
  } catch (err) {
    if (parseErrorPayload(err)?.errorCode !== NUMBER_LOCK_TIMEOUT) throw err;
    return await call();
  }
}
